export const RECEIVE_OUTLINES = "RECEIVE_OUTLINES";
export const SET_OUTLINE_IS_ACTIVE = "SET_OUTLINE_IS_ACTIVE";
export const TOGGLE_OUTLINE_IS_COLLAPSED = "TOGGLE_OUTLINE_IS_COLLAPSED";

export function receiveOutlines(outlines) {
  return {
    type: RECEIVE_OUTLINES,
    outlines,
  };
}

export function toggleOutlineIsCollapsed(id) {
  return {
    type: TOGGLE_OUTLINE_IS_COLLAPSED,
    outlineId: id,
  };
}

export function setOutlineIsActive(id, isActive) {
  return {
    type: SET_OUTLINE_IS_ACTIVE,
    id,
    isActive,
  }
}

